/**
 * Category Type Constants
 * Defines the types of dimension categories: FIXED and NON_FIXED
 */

export const CategoryType = {
  FIXED: 'FIXED',
  NON_FIXED: 'NON_FIXED',
};

export default CategoryType;